import { render, staticRenderFns } from "./MedicalRecordSetting.vue?vue&type=template&id=403d5e9d&scoped=true&"
import script from "./MedicalRecordSetting.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordSetting.vue?vue&type=script&lang=js&"
import style0 from "./MedicalRecordSetting.vue?vue&type=style&index=0&id=403d5e9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403d5e9d",
  null
  
)

export default component.exports